import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import jazzImage from "../images/jazz-trumpet.webp";
import JazzSong from "../music/jazz-coffee-309948.mp3";
// import ClassicSong from "../music/peaceful-piano-background-music-218762.mp3";
import { useState, useEffect } from "react";
import PauseIcon from "@mui/icons-material/Pause";

import "../css/contact.css";
export default function MusicCard() {
  const theme = useTheme();
  const [audio] = useState(new Audio(JazzSong)); // Path to your audio file
  const [isPlaying, setIsPlaying] = useState(false);
  useEffect(() => {
    audio.loop = true; // Set the loop property to true
  }, [audio]);
  // Handle play/pause functionality
  const togglePlayPause = () => {
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  // Cleanup audio on component unmount
  useEffect(() => {
    // togglePlayPause();
    return () => {
      audio.pause();
      audio.remove();
    };
  }, [audio]);

  return (
    <Card
      sx={{
        display: "flex",
        maxWidth: 400,
        backgroundColor: "transparent",
        color: "white",
        alignItems: "center",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <CardContent sx={{ flex: "1 0 auto" }}>
          <Typography
            component="div"
            variant="h5"
            style={{ fontFamily: "Trebuchet MS" }}
          >
            Typing is boring ?
          </Typography>
          <Typography
            variant="subtitle1"
            component="div"
            sx={{
              color: "white",
              letterSpacing: "1px",
              fontWeight: "lighter",
              fontFamily: "Trebuchet MS",
              marginTop: "5px",
            }}
          >
            Jazz IT !
          </Typography>
        </CardContent>
        <Box sx={{ display: "flex", alignItems: "center", pl: 1, pb: 1 }}>
          <IconButton aria-label="previous">
            {theme.direction === "rtl" ? (
              <SkipNextIcon sx={{ color: "white" }} />
            ) : (
              <SkipPreviousIcon sx={{ color: "white" }} />
            )}
          </IconButton>
          <IconButton aria-label="play/pause" onClick={() => togglePlayPause()}>
            {!isPlaying ? (
              <PlayArrowIcon sx={{ height: 38, width: 38, color: "white" }} />
            ) : (
              <PauseIcon sx={{ height: 38, width: 38, color: "white" }} />
            )}
          </IconButton>
          <IconButton aria-label="next">
            {theme.direction === "rtl" ? (
              <SkipPreviousIcon sx={{ color: "white" }} />
            ) : (
              <SkipNextIcon sx={{ color: "white" }} />
            )}
          </IconButton>
        </Box>
      </Box>
      <CardMedia
        className="jazzImage"
        component="img"
        sx={{
          width: 150,
          height: 150,
          borderRadius: "50%",
          animationName: isPlaying ? "rotate-jazz" : "",
        }}
        image={jazzImage}
        alt="Live from space album cover"
      />
    </Card>
  );
}
